import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { neutralDark20, neutralDark30, neutralDark40 } from "../../../constants/colors";
import { fontWeight } from "./typographyConstants";

/**
 * Font Sizing
 * (includes line height)
 */
export var fontSizeDefinitions = {
  "13": {
    fontSize: "13px",
    lineHeight: "18px"
  },
  "14": {
    fontSize: "14px",
    lineHeight: "18px"
  },
  "15": {
    fontSize: "15px",
    lineHeight: "18px"
  },
  "18": {
    fontSize: "18px",
    lineHeight: "24px"
  },
  "24": {
    fontSize: "24px",
    lineHeight: "28px"
  },
  "32": {
    fontSize: "32px",
    lineHeight: "34px"
  },
  "40": {
    fontSize: "40px",
    lineHeight: "48px"
  }
};

/**
 * Type ramp style definitions
 */
export var typeRampLodestarDefinitions = {
  headlineXLarge: _objectSpread({
    fontWeight: fontWeight.bold,
    fontFamily: "TT Norms Pro",
    color: neutralDark40
  }, fontSizeDefinitions["40"]),
  headlineLarge: _objectSpread({
    fontWeight: fontWeight.bold,
    fontFamily: "TT Norms Pro",
    color: neutralDark40
  }, fontSizeDefinitions["32"]),
  headlineMedium: _objectSpread({
    fontWeight: fontWeight.bold,
    fontFamily: "TT Norms Pro",
    color: neutralDark40
  }, fontSizeDefinitions["24"]),
  headlineSmall: _objectSpread({
    fontWeight: fontWeight.bold,
    fontFamily: "TT Norms Pro",
    color: neutralDark40
  }, fontSizeDefinitions["18"]),
  headerLarge: _objectSpread({
    fontWeight: fontWeight.semiBold,
    fontFamily: "default",
    color: neutralDark30
  }, fontSizeDefinitions["15"]),
  headerSmall: _objectSpread({
    fontWeight: fontWeight.semiBold,
    fontFamily: "default",
    color: neutralDark30
  }, fontSizeDefinitions["13"]),
  buttonLarge: _objectSpread({
    fontWeight: fontWeight.bold,
    fontFamily: "default",
    color: neutralDark30
  }, fontSizeDefinitions["14"]),
  buttonMedium: _objectSpread({
    fontWeight: fontWeight.semiBold,
    fontFamily: "default",
    color: neutralDark30
  }, fontSizeDefinitions["13"]),
  titlesEmphasis: _objectSpread({
    fontWeight: fontWeight.semiBold,
    fontFamily: "default",
    color: neutralDark30
  }, fontSizeDefinitions["13"]),
  bodyStrong: _objectSpread({
    fontWeight: fontWeight.medium,
    fontFamily: "default",
    color: neutralDark30
  }, fontSizeDefinitions["13"]),
  bodyText: _objectSpread({
    fontWeight: fontWeight.regular,
    fontFamily: "default",
    color: neutralDark30
  }, fontSizeDefinitions["13"]),
  metadata: _objectSpread({
    fontWeight: fontWeight.regular,
    fontFamily: "default",
    color: neutralDark20
  }, fontSizeDefinitions["13"])
};
//# sourceMappingURL=lodestarConstants.js.map